export const HOST_NAME_CLIENTS = 'clients';
export const HOST_NAME_PARTNERS = 'partners';
export const HOST_NAME_REPRESENTATIVES = 'representatives';
